import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../../domain/repository';
import { AuthLoginRequest, AuthLoginResponse } from '../../domain/dto';
import { HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  execute(credentials: AuthLoginRequest): Observable<HttpResponse<AuthLoginResponse>> {
    return this.authRepository.login(credentials);
  }
}


